import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
export default function textAnimation() {

    const $words = $(".text-animated .word");

    if ($words.length) {
        const words = $words.toArray();

        gsap.registerPlugin(ScrollTrigger);

        const isMedium = Foundation.MediaQuery.atLeast("medium");
        const speed = isMedium ? 20 : 15;
        const position = isMedium ? "top 60%" : "top 65%";
        const scrollLength = words.length * speed;

        gsap.timeline({
            scrollTrigger: {
                trigger: $(".text-animated").get(0),
                start: position,
                end: `+=${scrollLength}`,
                scrub: true,
            }
        }).to(words, {
            color: "#000000",
            stagger: { each: 1 },
            ease: "none"
        });
    }
}
